import React, { useState } from 'react';
import { professionalMoments } from '../data/corporateData';
import { X } from 'lucide-react';

const ProfessionalGallery = () => {
  const [selectedImage, setSelectedImage] = useState(null);

  return (
    <section className="py-16 sm:py-24 bg-[#0F172A]" id="gallery">
      <div className="container mx-auto px-4 sm:px-8 lg:px-16">
        {/* Section Header */}
        <div className="mb-12 max-w-3xl">
          <span className="text-xs font-bold tracking-[0.2em] uppercase text-rose-500 font-heading mb-4 block">
            Key Moments
          </span>
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-white mb-4 font-heading">
            Key Moments & Collaborations
          </h2>
          <p className="text-base text-slate-300 leading-relaxed font-body">
            Highlights from strategic partnerships and industry milestones
          </p>
        </div>

        {/* Gallery Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="professional-gallery">
          {professionalMoments.map((moment) => (
            <div
              key={moment.image}
              className="group relative overflow-hidden rounded-lg cursor-pointer bg-[#112240] border border-white/10 hover:border-rose-500/50 transition-all duration-300"
              onClick={() => setSelectedImage(moment)}
              data-testid={`gallery-item-${moment.category.toLowerCase().replace(/\s+/g, '-')}`}
            >
              <div className="aspect-[4/3] overflow-hidden">
                <img
                  src={moment.image}
                  alt={moment.caption}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-[#0A192F]/90 via-[#0A192F]/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <div className="absolute bottom-0 left-0 right-0 p-4">
                  <div className="text-xs text-rose-400 font-semibold mb-1 font-body uppercase tracking-wider">
                    {moment.category}
                  </div>
                  <div className="text-sm text-white font-medium font-body">
                    {moment.caption}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Lightbox Modal */}
      {selectedImage && (
        <div
          className="fixed inset-0 bg-black/95 z-50 flex items-center justify-center p-4"
          onClick={() => setSelectedImage(null)}
          data-testid="gallery-lightbox"
        >
          <button
            className="absolute top-4 right-4 text-white hover:text-rose-500 transition-colors"
            onClick={() => setSelectedImage(null)}
            data-testid="gallery-close"
          >
            <X size={32} />
          </button>
          <div className="max-w-5xl w-full">
            <img
              src={selectedImage.image}
              alt={selectedImage.caption}
              className="w-full h-auto rounded-lg"
            />
            <div className="mt-4 text-center">
              <div className="text-xs text-rose-400 font-semibold mb-2 font-body uppercase tracking-wider">
                {selectedImage.category}
              </div>
              <div className="text-lg text-white font-medium font-body">
                {selectedImage.caption}
              </div>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default ProfessionalGallery;
